export const getDefaultSeatTypes = (stageId: number) => [
    { id: 0, name: "一般", stageId, description: "" },
    { id: -1, name: "通路", stageId, description: "" }
]